import { DESKTOP_L, DESKTOP_S, MOBILE, TABLET } from '../lib/constant'

const breakpoints = {
	[MOBILE]: '0px',
	[TABLET]: '768px',
	[DESKTOP_S]: '1024px',
	[DESKTOP_L]: '1440px',
}

export default breakpoints
